import { useEffect, ReactNode } from 'react';
import {
  markAutoLoadAsChecked,
  markAutoLoadRedirecting,
} from '../pages/landing-page/LandingPageWrapper';

/**
 * A utility component that marks autoLoad as checked when mounted.
 * Used on non-landing-page routes to prevent autoLoad from triggering
 * when navigating to the landing page after initially loading on another route.
 */
function AutoLoadMarker({ children }: { children: ReactNode }) {
  useEffect(() => {
    markAutoLoadAsChecked();
    markAutoLoadRedirecting();
  }, []);

  return children;
}

export default AutoLoadMarker;
